import { apiForPrivate } from '.';
import { TRUSTED_DRIVER_ENDPOINT } from '../../config/ap';

const apiCourts = apiForPrivate.injectEndpoints({
    overrideExisting: true,
    endpoints: build => ({
        getCourtClients: build.query({
            query: (params) => ({
                url: `${TRUSTED_DRIVER_ENDPOINT.COURT_CLIENTS}`,
                params,
            })
        }),
        addCourtClient: build.mutation({
            query: (payload) => ({
                url: `${TRUSTED_DRIVER_ENDPOINT.COURT_CLIENTS}`,
                method: 'POST',
                body: payload,
            }),
        }),
        updateCourtClient: build.mutation({
            query: ({ id, ...payload }) => ({
                url: `${TRUSTED_DRIVER_ENDPOINT.COURT_CLIENTS}/${id}`,
                method: 'PUT',
                body: payload,
            }),
        }),
        deleteCourtClient: build.mutation({
            query: (id) => ({
                url: `${TRUSTED_DRIVER_ENDPOINT.COURT_CLIENTS}/${id}`,
                method: 'DELETE',
            }),
        }),
    })
});

export const {
    useLazyGetCourtClientsQuery,
    useAddCourtClientMutation,
    useUpdateCourtClientMutation,
    useDeleteCourtClientMutation,
} = apiCourts;
